module.exports = __webpack_public_path__ + "media/src/images/icons/credit-card-0868210d28db905ba2b08148202f7bf0.svg";